import React from "react";
import {useTranslation} from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import YellowButton from "../../common/buttons/YellowButton";
import SecondaryButton from "../../common/buttons/SecondaryButton";
import Seo from "../../common/Seo";
import Footer from "../../navigation/Footer";
import {EXTERNAL_LINKS} from "../../../config/external-links";
import "./Landing.css";

interface LandingProps {
    loginFunction: any;
}

// Public marketing landing page shown to unauthenticated visitors. Mirrors the
// Figma "MAIN WEB FOR APP" hero and the emdrlink.pl/app branding.
const Landing: React.FC<LandingProps> = ({loginFunction}) => {
    const {t} = useTranslation();

    const signIn = (event: any) => loginFunction(null, event);
    const signUp = (event: any) =>
        loginFunction({authorizationParams: {screen_hint: "signup"}}, event);

    return (
        <div className="landing">
            <Seo
                title={t("EMDR Online for therapists")}
                description={t("Create sessions, invite patients and run bilateral stimulation online. The patient joins via an individual link — nothing to install.")}
            />
            <div className="landing-hero">
                <div className="landing-copy">
                    <span className="landing-badge">{t("EMDR APP")}</span>
                    <h1 className="landing-title">
                        <span className="landing-title-em">EMDR Online</span>
                        <span>{t("for therapists")}</span>
                    </h1>
                    <p className="landing-lead">
                        {t("Create sessions, invite patients and run bilateral stimulation online.")}
                    </p>
                    <p className="landing-lead landing-lead-muted">
                        {t("The patient joins via an individual link (nothing to install).")}
                    </p>

                    <div className="landing-actions">
                        <div className="landing-action">
                            <span className="landing-action-label">{t("Already have an account?")}</span>
                            <YellowButton fullWidth size="large" onClick={signIn}>{t("Sign In")}</YellowButton>
                        </div>
                        <div className="landing-action">
                            <span className="landing-action-label">{t("First time here?")}</span>
                            <SecondaryButton fullWidth size="large" onClick={signUp}>{t("Sign Up")}</SecondaryButton>
                        </div>
                    </div>

                    <a
                        className="landing-more-link"
                        href={EXTERNAL_LINKS.about}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("Learn more about EMDR online")}
                        <ArrowForwardIcon className="landing-more-icon" />
                    </a>
                </div>

                <div className="landing-visual" aria-hidden="true">
                    <img className="mockup mockup-back" src="/landing/mockup-back.png" alt="" />
                    <img className="mockup mockup-right" src="/landing/mockup-right.png" alt="" />
                    <img className="mockup mockup-front" src="/landing/mockup-front.png" alt="" />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Landing;
